import { UserShort } from '@organization/api/requests'
import { paths } from '@organization/router'
import { getNameAcronym } from '@organization/utils'
import { getFullName } from '@shared/utils'
import { Avatar, Badge, BadgeProps, Flex, Typography } from 'antd'
import { Link } from 'react-router-dom'

type Props = {
  id?: number
  user?: UserShort
  status?: string
}

const getStatusColor = (status: string): BadgeProps['status'] => {
  return status === 'active' ? 'success' : 'default'
}

export const AvatarDetails = ({ id, user, status = '' }: Props) => {
  return (
    <Link to={paths.users.details(String(id))}>
      <Flex align="center" gap={16}>
        <Badge
          dot
          size="default"
          offset={[-3, 30]}
          status={getStatusColor(status)}
        >
          <Avatar src={user?.photo} size={32}>
            {getNameAcronym(getFullName(user))}
          </Avatar>
        </Badge>

        <div>
          <Typography.Paragraph>{getFullName(user)}</Typography.Paragraph>
          {user?.email && (
            <Typography.Paragraph>{user?.email}</Typography.Paragraph>
          )}
        </div>
      </Flex>
    </Link>
  )
}
